
























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { WebhooksModule } from '@/store/Settings/WebhooksModule';
import UpdateWebhookRequest from '@/models/Settings/Webhooks/UpdateWebhookRequest';

@Component({ name: 'WebhookEdit' })
export default class extends SaascadaVueDialog {

    request: UpdateWebhookRequest = new UpdateWebhookRequest();

    @Watch('dialog')
    onDialogChanged(val: boolean) {
        if (val) {
            this.request = new UpdateWebhookRequest();
            this.request.name = WebhooksModule.webhook.name;
            this.request.enabled = WebhooksModule.webhook.enabled;
            this.request.url = WebhooksModule.webhook.url;
        }
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;
            await WebhooksModule.editWebhook(this.request);
        }
    }

}
